export default __webpack_public_path__ + "static/media/servishero-loading.bc2f4244.gif";